import { Box } from "@mui/material"
import SphereElement from "./SphereElement"
import { useState } from "react"
import { OotItemDto } from "../hints/OotItemAutocomplete"



const OutOfLogicDisplay = () => {


    return <Box display={"flex"} flexDirection={"column"}>
        {([...Array.from(Array(5).keys())].map(i => {
            return <Box key={"line " + i} display={"flex"} flexDirection={"row"}>
                {[...Array.from(Array(5).keys())].map((ee,ii) => {
                 return <OoLSphereElement />
            })}
            </Box>
        }))
        }
    </Box>
}

export default OutOfLogicDisplay


const OoLSphereElement = () => {

    let [item, setItem] = useState<OotItemDto |null>(null)
    return <SphereElement barren changeItemLocationOnChildChange={(e) => {}} id={0} sphereLevel={0} isOutOfLogic item={item} onItemChange={setItem}/>
}